var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"main-panel-wrapper p-1",class:{ 'shrunk': _vm.isSideBarOpen }},[_c('div',{staticClass:"main-panel h-100 shadow-lg"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }